import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Create_Quality, Quality } from 'src/app/Interfaces/GeneralCDMS/Quality.interface';
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-quality-polici-cdms',
    templateUrl: './quality-polici-cdms.component.html',
    styleUrls: ['./quality-polici-cdms.component.scss', './../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class QualityPoliciCDMSComponent implements OnInit {

  @ViewChild('AddQuality')
  MyInputAddQuality!: ElementRef;

  //+================== VARIABLES BAND FOR UPDATE OR NEW LOAD ==================+\\
  public IsUpdate: boolean = false;


  //+================== VARIABLES GLOBAL FILES QUALITY ==================+\\
  public All_Qualitys: Quality[] = [];


  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddQuality: FILE_CAP = { FileData: null, FileName: '' };
  public Quality_Selected: Quality = {
    ID: 0,
    ID_Contributor: 0,
    Name: '',
    Extension: '',
    Status: 0,
    ID_Next_Version: 0,
    ID_Previous_Version: 0,
    Upload_Date: null,
  }

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private PermissionFolder = inject(PermisionsFolderService);
  private Service_FIN = inject(LibraryFINService); // FOR DOWNLOAD FILES

  constructor() { }

  ngOnInit(): void {
    this.Load_Component();
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {
    this.LoadPage = false;
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      await this.Load_All_Qualitys();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Quality)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      }); Loader.classList.remove('active');
    }
  }

  //-================== FUNCTION FOR LOAD QUALITYS ==================-\\
  private async Load_All_Qualitys(): Promise<boolean> {
    try {

      const Response_Quality: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_Qualitys_CDMS());

      if (Response_Quality.success) {
        this.All_Qualitys = Response_Quality.operation;
      }

      return true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Quality)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return true;
    }
  }


  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION RETURN CLASS FILE ==================-\\
  public Type_Extension_Class(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Class || 'not-found';
  }

  //-================== FUNCTTION FOR RETURN URL IMAGE ==================-\\
  public Type_Extension_Img(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Url_Image.toLowerCase() || 'not-found.png';
  }

  //-================== FUNCTTION FOR VERIFICATE IF UPDATE OR NEW MODAL ==================-\\
  public OpenModalIsUpdate(IsUpdate: boolean, Quality: Quality | null): void {
    this.IsUpdate = IsUpdate;
    if (Quality !== null) this.Quality_Selected = Quality;

    this.ToggleModalAddQuality(true);
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  public Cut_Name(NameQuality: string): string {

    let NameQuality_List = NameQuality.split('.');
    NameQuality_List.pop();

    const Name_Clen: string = NameQuality_List.join('.');

    return Name_Clen.length > 40 ? Name_Clen.slice(0, 40) + '...' : Name_Clen;

  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SEND AND UPDATE QUALITY =====================&\\

  //-================== FUNCTTION OPEN OR CLOSE MODAL ADD QUALITY ==================-\\
  public ToggleModalAddQuality(CloseOrOpen: boolean): void {
    const ModalAddQuality = document.getElementById('ModalAddQuality') as HTMLElement;
    CloseOrOpen ? ModalAddQuality.classList.add('active') : ModalAddQuality.classList.remove('active');
  }

  //-================== FUNCTION FOR ADD CLASS HOVER INPUT FILE ==================-\\
  public Load_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.add('active');
  }

  //-================== FUNCTION FOR REMOVE CLASS HOVER INPUT FILE ==================-\\
  public Onload_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.remove('active');
  }

  //-================== FUNCTION TO CAPTURE FILE UPLOAD (QUALITY) ==================-\\
  public Load_Document_Quality(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxAddQuality = {
        FileData: file,
        FileName: file.name
      }


      !this.IsUpdate ? this.Send_Quality() : this.Send_Update_Quality();

    }
    this.Onload_File();
    this.MyInputAddQuality.nativeElement.value = null;
  }

  //-================== FUNCTION FOR SEND NEW QUALITY ==================-\\
  private Send_Quality(): void {

    const Create_Quality: Create_Quality = {
      Name: this.FileAuxAddQuality.FileName,
      Extension: this.FileAuxAddQuality.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: null,
    }

    Swal.fire({
      title: '¿Está seguro de cargar esta política de calidad?',
      text: `¡El nombre es ${this.FileAuxAddQuality.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, Cargar política de calidad!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Quality(true);

        const Container_Progress_Quality = document.getElementById('Container-Progress-Quality') as HTMLDivElement;
        Container_Progress_Quality.classList.add('active');

        setTimeout(async () => {

          try {

            const ResQuality: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_Quality(Create_Quality));

            if (ResQuality.success) {
              const Quality: Quality = ResQuality.operation;

              await this.Send_File_Modal(Quality);

              Container_Progress_Quality.classList.remove('active');
              this.Animation_Modal_Quality(false);
              this.ToggleModalAddQuality(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'política de calidad cargada correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error al cargar',
              text: '¡No se guardo la política de calidad en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Quality.classList.remove('active');
            this.Animation_Modal_Quality(false);
            this.ToggleModalAddQuality(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //-================== FUNCTION FOR SEND DATA QUALITY ==================-\\
  private Send_File_Modal(Quality: Quality): Promise<boolean> {

    return new Promise((resolve, reject) => {


      const TextProgress = document.getElementById('TextProgress') as HTMLDivElement;
      const Progress_Bar_Quality = document.getElementById('Progress-Bar-Quality') as HTMLDivElement;

      const File = new FormData();

      File.append('File_Quality', this.FileAuxAddQuality.FileData, encodeURIComponent(Quality.ID + '.' + Quality.Extension))

      try {

        this.Service_GeneralCDMS.Upload_Quality_File(File).subscribe(async (event: any) => {

          if (event.status === 500) {

            Progress_Bar_Quality.style.width = "0%";
            TextProgress.innerHTML = "0%";
            Swal.fire({
              title: 'Error en la política de calidad',
              text: '¡Ha ocurrido un error al cargar la política de calidad, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar_Quality.style.width = value + "%";
            TextProgress.innerHTML = value + "%";
          }

          if (event['body']) {
            Progress_Bar_Quality.style.width = "0%";
            TextProgress.innerHTML = "0%";
            resolve(true);
          }

        })

      } catch (e) {
        Swal.fire({
          title: 'Error en política de calidad',
          text: '¡No se guardo política de calidad en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }

    })

  }

  //-================== FUNCTION FOR SEND QUALITY FILE  ==================-\\
  private Animation_Modal_Quality(DiabledOrEnabled: boolean): void {
    const Pro_popup3 = document.getElementById('Pro-popup3') as HTMLDivElement;
    const Pro_inside3 = document.getElementById('Pro-inside3') as HTMLDivElement;
    const Pro_content3 = document.getElementById('Pro-content3') as HTMLDivElement;
    DiabledOrEnabled ? Pro_popup3.classList.add('active') : Pro_popup3.classList.remove('active');
    DiabledOrEnabled ? Pro_inside3.classList.add('active') : Pro_inside3.classList.remove('active');
    DiabledOrEnabled ? Pro_content3.classList.add('active') : Pro_content3.classList.remove('active');
  }

  //-================== FUNCTION FOR SEND UPDATE QUALITY ==================-\\
  private Send_Update_Quality(): void {

    const Create_Quality: Create_Quality = {
      Name: this.FileAuxAddQuality.FileName,
      Extension: this.FileAuxAddQuality.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: this.Quality_Selected.ID,
    }

    Swal.fire({
      title: '¿Está seguro de actualizar la política de calidad?',
      text: `¡El nombre es ${this.FileAuxAddQuality.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, actualizar política de calidad!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Quality(true);

        const Container_Progress_Quality = document.getElementById('Container-Progress-Quality') as HTMLDivElement;
        Container_Progress_Quality.classList.add('active');

        setTimeout(async () => {

          try {

            const ResQuality: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_Quality(Create_Quality));

            if (ResQuality.success) {
              const Quality: Quality = ResQuality.operation;

              await this.Send_File_Modal(Quality);

              Container_Progress_Quality.classList.remove('active');
              this.Animation_Modal_Quality(false);
              this.ToggleModalAddQuality(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'política de calidad cargada correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en política de calidad',
              text: '¡No se guardo política de calidad en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Quality.classList.remove('active');
            this.Animation_Modal_Quality(false);
            this.ToggleModalAddQuality(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //&===================== END FUNCTIONS FOR SEND AND UPDATE QUALITY =====================&\\


  //&===================== FUNCTIONS FOR OPTION CARD =====================&\\


  //-============== FUNCTION FOR DOWNLOAD QUALITY ==============\\
  public async Download_Quality(Quality: Quality): Promise<void> {

    try {

      const ResGetURLQuality: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_URL_Download_Quality({ ID: Quality.ID }));

      if (ResGetURLQuality.success) {

        const URL = ResGetURLQuality.operation.URL_Quality;

        const IsDownload = this.Download_File_Quality(URL, Quality.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el Quality, informa a tu supervisor!'
      })
    }

  }

  private async Download_File_Quality(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Quality descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el Quality, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  public Delete_Quality(Quality: Quality): void {

    let NameQuality = Quality.Name.split('.');
    NameQuality.pop();

    const Name_Clen: string = NameQuality.join('.');

    Swal.fire({
      title: 'Eliminar política de calidad',
      icon: 'warning',
      text: `¿Desea eliminar la política de calidad ${Name_Clen}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((async result => {

      if (result.isConfirmed) {

        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminarla escriba ${Name_Clen} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === Name_Clen.toLowerCase()) {

              try {

                const ResDelete: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Delete_Quality_CDMS({ ID: Quality.ID }));

                if (ResDelete.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'política de calidad eliminada',
                    text: '¡Se elimino correctamente la política de calidad!',
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component();
                }

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar la política de calidad',
                  text: '¡No se eliminó la política de calidad, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre de la política de calidad para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }

    }))
  }

  //&===================== END FUNCTIONS FOR OPTION CARD =====================&\\


}
